import { render, staticRenderFns } from "./IcoExclamationCircle.vue?vue&type=template&id=534e8786"
import script from "./IcoExclamationCircle.vue?vue&type=script&lang=js"
export * from "./IcoExclamationCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports